<div class="report-argus-sync-dialog" [class.close]="shouldClose" [class.canClose]="canClose">
  <div class="report-argus-sync-dialog-container">
    <div *ngIf="canClose" class="closeButton" (click)="closeClicked()"></div>
    <div class="upper-text currency-management-description">
      <h2>{{ 'reportArgusSyncDialog.title' | translate}}</h2>
    </div>

    <section class="mainSection main-content">
      <div *ngIf="!config.length && reportIds.length > 0">
        {{ 'reportArgusSyncDialog.initializing' | translate}}
      </div>
      <div *ngIf="reportIds.length == 0" style="color: red;">
        {{ 'reportArgusSyncDialog.reportsMissing' | translate}}
      </div>
      <div *ngIf="config.length" class="messages-container">
        <ng-container *ngFor="let reportConfig of config">
          <span class="reportId">{{ 'reportArgusSyncDialog.report' | translate}} {{reportConfig.reportId}}:</span>
          <ng-container *ngFor="let message of reportConfig.messages">
            <div class="message" [class.error]="message.level === 'ERROR'" [class.success]="message.level === 'SUCCESS'">
              {{message.timestamp | date: 'dd.MM.yyyy HH:mm:ss'}}: {{message.message}}
            </div>
          </ng-container>
        </ng-container>

        <div class="allDone" *ngIf="isSuccessOrFailure">
          {{ 'reportArgusSyncDialog.allDone' | translate}}
        </div>
      </div>
    </section>
  </div>
</div>
